export const PRICE_ALERTS = 'price_alerts';
export const FILTERS = 'filters';
